import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { RelayDashboardComponent } from "./relay-dashboard/relay-dashboard.component";

const routes: Routes = [
	{
		path: "",
		component: RelayDashboardComponent,
	},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RelayDashboardRoutingModule { }
